import { FeedbackRequestLimits } from '../types/api'

// Used when a company has no feedbackRequest configured
export const DEFAULT_FEEDBACK_REQUEST_LIMITS: FeedbackRequestLimits = {
  manager: { max: 1, min: 1 },
  peer: { max: 3, min: 1 },
  reportee: { max: 3, min: 1 },
}
